import { modelOptions, post, prop, PropType } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import { LoggerSchedule } from "./loggerSchedule.js";

const SCHEMA_KEY = "LoggerParsedDownlink" as const;

/** The bit-encoded representation of a single schedule transition, as sent over the wire. */
class ScheduleBit {
    @prop({ type: () => Boolean, required: true })
    public transitionBit!: boolean;

    @prop({ type: () => Number, required: true }, PropType.ARRAY)
    public delays!: number[];

    @prop({ type: () => String, required: true })
    public delayBits!: string;

    @prop({ type: () => String, required: true })
    public permuteBits!: string;
}

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerParsedDownlink>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerParsedDownlink extends SchemaBase<LoggerParsedDownlink> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Date, required: false })
    public referenceTime?: Date;

    @prop({ type: () => LoggerSchedule, required: false }, PropType.ARRAY)
    public schedules?: LoggerSchedule[];

    @prop({ type: () => Number, required: false })
    public valveCount?: 1 | 2;

    @prop({ type: () => ScheduleBit, required: false }, PropType.ARRAY)
    public scheduleBits?: ScheduleBit[];

    static getters = {} as const satisfies Record<string, (self: LoggerParsedDownlink) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerParsedDownlink>) {
        super(properties);
        Object.assign(this, properties);
    }
}
